<template>
    <header ref="root" class="page-header" v-if="getMenuIdFromType('header')">
        <pre class="critical-js">
            if(localStorage.getItem('preloadDimensions') !== null) {
                var style = document.createElement('style');
                style.innerHTML = '';
                style.innerHTML += '.page-header { height: '+ JSON.parse(localStorage.getItem('preloadDimensions'))[0] + 'px' + ' }';
                style.innerHTML += '.page-wrap { padding-top: '+ JSON.parse(localStorage.getItem('preloadDimensions'))[0] + 'px' + ' }';
                style.innerHTML += '.logo__link { height: '+ JSON.parse(localStorage.getItem('preloadDimensions'))[1] + 'px' + ' }';
                document.head.appendChild(style);
            }
        </pre>
        <div v-bind:class="generateClassForMenu(getMenuIdFromType('header'))">
            <div class="header-outer-container bg-color-menu">
                <div class="header-container container__boxed">
                    <div class="menu-header-inner flex--wrap">
                        <div class="logo color-menu">
                            <a
                                v-on:click.prevent="scrollInsideEditor"
                                v-bind:href="'/#top'"
                                class="logo__link"
                            >
                                <img
                                    v-if="logo"
                                    class="logo__image"
                                    v-bind:src="
                                        generateMediaUrl({
                                            id: logo,
                                            h: getAllowedLogoHeightFromType(
                                                getMenuIdFromType('header')
                                            )
                                        })
                                    "
                                    alt=""
                                />
                                <span
                                    v-else-if="getProp('deha.user.firma1')"
                                    class="logo__text font-bold"
                                    >{{ getProp('deha.user.firma1') }}</span
                                >
                            </a>
                        </div>

                        <nav
                            class="mainmenu"
                            role="navigation"
                            aria-label="Main menu"
                            id="mainmenu__nav"
                        >
                            <input
                                aria-expanded="false"
                                aria-controls="mainmenu__nav"
                                type="checkbox"
                                class="mainmenu__state"
                                id="mainmenu__state"
                            />
                            <label
                                role="button"
                                for="mainmenu__state"
                                class="mainmenu__toggle color-toggle"
                                >MENÜ</label
                            >
                            <ul
                                class="mainmenu__items flex--wrap bg-color-submenu border-color-highlighted"
                            >
                                <template v-if="!hasPackageBasic">
                                    <li
                                        class="mainmenu__item"
                                        v-for="items__value in itemsStarter"
                                        v-bind:key="items__value.id"
                                    >
                                        <a
                                            class="mainmenu__link color-menu border-color-highlighted"
                                            v-on:click.prevent="scrollInsideEditor"
                                            v-bind:href="'/' + $route.name + '#' + items__value.id"
                                            ><span>{{ items__value.name }}</span></a
                                        >
                                    </li>
                                </template>
                                <template v-if="hasPackageBasic">
                                    <li
                                        class="mainmenu__item"
                                        v-for="items__value in itemsBasic"
                                        v-bind:key="items__value.id"
                                        v-if="
                                            editorMode ||
                                                (items__value.visible && items__value.accessible)
                                        "
                                        v-bind:style="{
                                            opacity:
                                                items__value.visible && items__value.accessible
                                                    ? 1
                                                    : 0.25
                                        }"
                                    >
                                        <router-link
                                            v-bind:to="
                                                '/' +
                                                    $route.name +
                                                    (items__value.slug !== '/'
                                                        ? items__value.slug
                                                        : '')
                                            "
                                            :class="[
                                                'mainmenu__link color-menu module__link border-color-highlighted',
                                                {
                                                    'mainmenu__link--active font-bold color-menu-active module__link border-color-highlighted':
                                                        getActivePageId == items__value.id
                                                }
                                            ]"
                                            ><span>{{ items__value.name }}</span></router-link
                                        >
                                    </li>
                                </template>
                            </ul>
                        </nav>

                        <app-modulebackground
                            :menu-id="getMenuIdFromType('header')"
                        ></app-modulebackground>
                    </div>
                </div>
            </div>
        </div>

        <app-configbar
            v-if="editorMode"
            :show-data="true"
            :show-layout="true"
            :show-appearance="true"
            :slim="true"
            v-on:open="toggleActive($event)"
        >
        </app-configbar>
    </header>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters, mapActions } from 'vuex';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import PageHeader from '@/external/assorted/PageHeader';
import Configbar from '@/components/assorted/Configbar.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebackground': ModuleBackground,
        'app-configbar': Configbar
    },
    methods: {
        ...mapActions(['scrollInsideEditor']),
        toggleActive(configurator_view) {
            if (this.getActiveConfiguratorView === configurator_view) {
                this.$router.push({ name: 'editor', params: { page: this.getActivePageRoute } });
            } else {
                this.$router.push({
                    name: 'editor',
                    params: { page: this.getActivePageRoute },
                    query: {
                        configurator: 1,
                        configurator_group: 'menus',
                        configurator_view: configurator_view,
                        menu_id: this.getMenuIdFromType('header')
                    }
                });
            }
        }
    },
    computed: {
        ...mapGetters([
            'getPages',
            'getActiveConfiguratorView',
            'getMenuFromType',
            'getMenuIdFromType',
            'getActivePageId',
            'getActivePageRoute',
            'hasPackageBasic',
            'getModules',
            'getModuleDataByType',
            'getPageIdFromSlug',
            'getProp',
            'generateMediaUrl',
            'editorMode',
            'generateClassForMenu',
            'getMenuBackground',
            'getAllowedLogoHeightFromType',
            'getLayoutType'
        ]),
        itemsStarter() {
            return toArray(this.getModules)
                .filter((i) => i.page_id === this.getPageIdFromSlug('/'))
                .filter((i) => this.getModuleDataByType(i.type).restrictions.showInStarterMenu)
                .sort((a, b) => a.pos - b.pos);
        },
        itemsBasic() {
            return toArray(this.getPages)
                .filter((i) => i.menu_id === this.getMenuIdFromType('header'))
                .sort((a, b) => a.pos - b.pos);
        },
        logo() {
            return this.getProp('deha.user.misc.logo.id');
        }
    },
    updated() {
        let i = new PageHeader();
        i.dynamicallySetHeaderDimensions();
    },
    created() {},
    mounted() {
        if (this.editorMode) {
            let i = new PageHeader();
            i.init(this.$refs.root);

            // also set small right padding for scrollbar (this is only inside editor)
            if (document.querySelector('.page-wrap') !== null) {
                let val =
                    document.querySelector('.page-wrap').offsetWidth -
                    document.querySelector('.page-wrap').clientWidth +
                    'px';
                this.$refs.root.style.paddingRight = val;
                if (this.$refs.root.querySelector('.configbar') !== null) {
                    this.$refs.root.querySelector('.configbar').style.right = val;
                }
            }
        }
    },
    props: {}
};
</script>
